export default __webpack_public_path__ + "static/media/rzprono.0a8b4be2.jpeg";